import './testimonial-slider.scss';
import 'slick-carousel';

export default () => {
	let $jsStepsSlider = $( '.js-testimonial-slider' );

	$jsStepsSlider.slick( {
		rows: 0,
		infinite: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		swipeToSlide: true,
		fade: true,
		arrows: true,
		dots: false,
		prevArrow: '.js-testimonial-prev',
		nextArrow: '.js-testimonial-next',
	} );
};
